import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  border: 1px dashed #ccc;
  padding: 5px;
  width: 100%;
  height: 900px;
`;

// export const ToolBar = styled.div`
//   padding: 5px 0;
//   display: flex;
//   align-items: center;

//   > button {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     background: none;
//     border: 1px solid #ccc;
//     border-radius: 5px;
//     margin-right: 5px;
//     width: 30px;
//     height: 30px;
//   }
// `;

export const ToolBar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px;
  margin-bottom: 6px;
  background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);
  /* border: 1px solid rgba(216, 224, 235, 0.9); */
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(23, 38, 59, 0.05);

  > button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border: 1px solid rgba(216, 224, 235, 0.9);
    border-radius: 10px;
    background: #fff;
    color: #5b6b82;
    cursor: pointer;
    transition: color 0.18s ease, background 0.18s ease, border-color 0.18s ease,
      box-shadow 0.18s ease, transform 0.18s ease;

    > svg {
      display: block;
    }

    &:hover:not(:disabled) {
      color: #ff6d3c;
      background: rgba(255, 109, 60, 0.1);
      border-color: rgba(255, 109, 60, 0.45);
      box-shadow: 0 6px 14px rgba(255, 109, 60, 0.18);
      transform: translateY(-1px);
    }

    &:active:not(:disabled) {
      transform: translateY(0);
      box-shadow: 0 3px 8px rgba(255, 109, 60, 0.22);
    }

    &:focus-visible {
      outline: none;
      border-color: rgba(255, 109, 60, 0.6);
      box-shadow: 0 0 0 3px rgba(255, 109, 60, 0.18);
    }

    &:disabled {
      color: #c2cad6;
      background: #f1f5f9;
      border-color: rgba(216, 224, 235, 0.7);
      cursor: not-allowed;
      box-shadow: none;
      transform: none;
    }

    /* botão primário (Salvar / submit) em destaque */
    &[type='submit'] {
      color: #fff;
      background: linear-gradient(135deg, #22c55e 0%, #2bd66b 100%);
      border-color: transparent;
      box-shadow: 0 6px 14px rgba(34, 197, 94, 0.28);

      &:hover:not(:disabled) {
        color: #fff;
        background: linear-gradient(135deg, #1fb555 0%, #28c763 100%);
        border-color: transparent;
        box-shadow: 0 10px 20px rgba(34, 197, 94, 0.4);
        transform: translateY(-1px);
      }
    }
  }
`;

export const Image = styled.img`
  ${(props) =>
    props.orientation === 'portrait'
      ? css`
          height: 874px;
          width: 614px;
        `
      : css`
          height: 614px;
          width: 874px;
        `}
`;
